module.exports = __webpack_public_path__ + "img/hair-behind-shoulders.591a065d.png";